import { Button } from 'flowbite-react';
import { Img } from 'react-image';
import { useNavigate } from 'react-router-dom';
import React, { useContext } from 'react';
import { ThemeContext } from 'src/context/ThemeProvider';

const CreateYourLevelUpAccountBanner = () => {
	const navigate = useNavigate();
	const ThemeContextState = useContext(ThemeContext);
	return (
		<div
			className="relative isolate flex h-full w-full flex-row overflow-hidden justify-between px-6 gap-x-4 rounded-[8px] bg-[#FFF] dark:bg-[#1F2A37]
             md:max-h-[180px] border border-[#EBEBF0] dark:border-none"
		>
			<img className="absolute right-0 z-[-1]" src="/assets/sharable-job-bg-light.svg" alt="" />
			<div className="flex w-full flex-col gap-3 px-3 py-4 font-inter md:max-w-[70%]">
				<p className="bg-gradient-to-br from-teal-400 to-green-600 bg-clip-text text-[20px] font-[700] text-transparent">
					Create your LevelUp account
				</p>
				<p className="text-[14px] dark:text-[#C7C9D9] text-[#555770]  max-w-[550px]">
					Create a free account on LevelUp, surpass your resume! Take the technical round and unlock job opportunities.
				</p>
				<div className="flex items-center gap-3">
					<Button
						className="hidden dark:block rounded-[8px] bg-gradient-to-br border-0 p-1 from-blue-500 to-blue-900 hover:bg-gradient-to-br hover:from-blue-600 hover:to-blue-900"
						onClick={() => navigate(`/auth/register?callback=${encodeURIComponent(`${window.location.href}`)}`)}
					>
						Create Your Profile
					</Button>
					<Button
						style={{
							borderRadius: '10px',
							background: 'var(--Dark-Gradient-Blue, linear-gradient(147deg, #5B8DEF 6.95%, #0063F7 93.05%))',
						}}
						className="block dark:hidden rounded-[8px] bg-gradient-to-br border-0 p-1"
						onClick={() => navigate(`/auth/register?callback=${encodeURIComponent(`${window.location.href}`)}`)}
					>
						Create Your Profile
					</Button>
					<Button
						color={ThemeContextState.themeMode}
						className="tex-white rounded-[8px] !border-[2px] !border-[#466cbe]"
						onClick={() => navigate(`/auth/signin?callback=${encodeURIComponent(`${window.location.href}`)}`)}
					>
						Log In
					</Button>
				</div>
			</div>
			<div className="my-auto flex h-full w-full items-center justify-end sm:hidden md:max-w-[30%] ">
				<Img src={'/assets/schedule.svg'} width={144} height={143} alt="interviewschedule" />
			</div>
		</div>
	);
};

export default CreateYourLevelUpAccountBanner;
